const prefix = 'ANNUAL_REVIEW_REPORT';

export const OPEN_ANNUAL_REVIEW_REPORT = `${prefix}/OPEN_ANNUAL_REVIEW_REPORT`;
export const CLOSE_ANNUAL_REVIEW_REPORT = `${prefix}/CLOSE_ANNUAL_REVIEW_REPORT`;
export const FETCH_ANNUAL_REVIEW_REPORT = `${prefix}/FETCH_ANNUAL_REVIEW_REPORT`;
export const SET_ANNUAL_REVIEW_REPORT_DATA = `${prefix}/SET_ANNUAL_REVIEW_REPORT_DATA`;
export const SET_ANNUAL_REVIEW_REPORT_LOADING = `${prefix}/SET_ANNUAL_REVIEW_REPORT_LOADING`;
export const SET_ANNUAL_REVIEW_REPORT_DATE_RANGE = `${prefix}/SET_ANNUAL_REVIEW_REPORT_DATE_RANGE`;
export const SET_CLIENT_TYPE = `${prefix}/SET_CLIENT_TYPE`;
export const GENERATE_CLAUDE_PROMPT = `${prefix}/GENERATE_CLAUDE_PROMPT`;

export const openAnnualReviewReport = hubId => ({
  type: OPEN_ANNUAL_REVIEW_REPORT,
  data: { hubId },
});

export const closeAnnualReviewReport = () => ({
  type: CLOSE_ANNUAL_REVIEW_REPORT,
});

export const fetchAnnualReviewReport = dateRange => ({
  type: FETCH_ANNUAL_REVIEW_REPORT,
  data: { dateRange },
});

export const setAnnualReviewReportData = data => ({
  type: SET_ANNUAL_REVIEW_REPORT_DATA,
  data,
});

export const setAnnualReviewReportLoading = data => ({
  type: SET_ANNUAL_REVIEW_REPORT_LOADING,
  data,
});

export const setAnnualReviewReportDateRange = dateRange => ({
  type: SET_ANNUAL_REVIEW_REPORT_DATE_RANGE,
  data: { dateRange },
});

export const setClientType = clientType => ({
  type: SET_CLIENT_TYPE,
  data: { clientType },
});

export const generateClaudePrompt = () => ({
  type: GENERATE_CLAUDE_PROMPT,
});

// selectors
export const annualReviewReportSelector = ({ annualReviewReport }) =>
  annualReviewReport;
